import { Injectable } from '@angular/core';
import { ServiceLocator } from '../ServiceLocator';
import { DivisionDTO } from '../api/plyca-dtos';
import { PlycaDataService } from '../../services/plyca.service';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ProjectEntityDTO, DossierSituation } from '../api/plyca-dtos-v2';
import { Configuration } from '../conf/app.constants';
import { AppConfiguration } from '../conf/app.configuration';

@Injectable()
export class DossierService {
  appConfig: AppConfiguration;
  constructor(public plycaService: PlycaDataService,
    public configuration: Configuration) {



    this.appConfig = ServiceLocator.injector.get(AppConfiguration);
  }

  public getColor(dossier: any): string {
    // switch (this.dossier.division.phase.identifier) {

    let a;

    // this.dossier.division.phase.identifier.identifier;
    if (dossier.division.phase.identifier.identifier) {
      a = dossier.division.phase.identifier.identifier;
    }

    if (dossier.phase.identifier) {
      a = dossier.phase.identifier;
    }

    switch (a) {
      case '0': {
        return 'black';
      }
      case '1': {
        return 'gray';
      }
      case '10': {
        return '#aabb00';
      }
      case '21': {
        return '#bb00bb';
      }
      case '23': {
        return '#bbbbcc';
      }
      case '40': {
        return '#00bbbb';
      }
      case '50': {
        return '#cccccc';
      }
      default: {
        //          console.log ('no tratado: ' + exp.fase.id);
        return 'red';
      }
    }
  }

  // fas fa-play  text-info
  public getSituacionIcon(dossier: any): string {
    switch (dossier.situacionEstado) {
      case 'EN-TRAMITACION': {
        return 'fas fa-play  text-info';
      }
      case 'CANCELADO': {
        return 'fa-ban  text-danger';
      }
      case 'PAUSADO': {
        return 'fa-pause  text-warning';
      }
      case 'PAUSADO': {
        return 'fa-square  text-info';
      }
      case 'EXTINGUIDO': {
        return 'fa-check text-ok';
      }
      case 'SOPORTE': {
        return 'fa-wrench text-danger';
      }
      case 'MANUAL': {
        return 'fa-hand-paper text-ok';
      }
      case 'SIN-TRAMITAR': {
        return 'fa-info text-danger';
      }
      case 'ARCHIVADO': {
        return 'fa-inbox text-info';
      }

      default: {
        return 'fa-stack-2x fa-question  text-warning';
      }
    }
  }
  public getSituacionPorcentaje(dossier: any): string {
    switch (dossier.situacionEstado) {
      case 'EN-TRAMITACION': {
        return 'width: 15%';
      }
      case 'CANCELADO': {
        return 'width: 50%';
      }

      case 'PAUSADO': {
        return 'width: 50%';
      }
      case 'EXTINGUIDO': {
        return 'width: 100%';
      }
      case 'SOPORTE': {
        return 'width: 50%';
      }

      default: {
        return 'width: 10%';
      }
    }
  }

  public getDivisionsTree(dossierId: string, expansion = 'project,project.expansionSet:minimal'): Observable<DivisionDTO> {
    return this.plycaService.getDossierDivisions(dossierId, expansion).pipe(
      map(result => {
        if (result && result.content) {
          let _divisiones: DivisionDTO[] = result.content;
          let root: DivisionDTO = _divisiones.find(
            division => division.parent === undefined
          );
          this.recurseDivisions(root, _divisiones);
          return root;
        }
      })
    );
  }

  recurseDivisions(parent: DivisionDTO, _divisiones: Array<DivisionDTO>) {
    parent.children = _divisiones.filter(
      division =>
        division.parent !== undefined &&
        division.parent.identifier === parent.identifier
    );

    if (parent.children && parent.children.length > 0) {
      parent.children.forEach(division =>
        this.recurseDivisions(division, _divisiones)
      );
    }
  }

  // fas fa-play  text-info
  public canAccess(id: any): Observable<boolean> {

    return this.plycaService
      .get(this.configuration.PROJECTENTITY_SERVICE_URL, id, this.getQueryParams())
      .pipe(
        take(1),
        map((param: ProjectEntityDTO) => (true))

      )

  }

  public canPrepare(id: any): Observable<boolean> {

    return this.plycaService
      .get(this.configuration.PROJECTENTITY_SERVICE_URL, id, this.getQueryParams())
      .pipe(
        take(1),
        map((param: ProjectEntityDTO) => (param.phase.identifier === '0<>EXPFASE'))

      )

  }

  private getQueryParams() {
    return {
      expand: 'expansionSet:minimal'
    };
  }

  //validamos que el tipo de expediente especificado (listadocnombre) se encuentra dentro de los permitidos (propiedad= documents.newDocument.dossierType)
  //botón Otros Docs (Crear Documento)
  /*
  hasDossierType(dossierType: string, types: string) {
    // si la lista de roles viene con * devolvemos true
    if (types === '*') {
      return true;
    }

    let ret = false;
    let dossierTypes = types.split(',');
    if (dossierTypes && dossierType) {

      let obj = dossierTypes.find(
        typeItem => typeItem == dossierType.trim()
      );
      ret = ret || obj !== undefined;
    }
    return ret;
  }
  */
}
